// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3_OzC","left":"InfoRow_left__3B5F1"};